<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card shadow="always">
          <div class="wrap">
            <i class="el-icon-s-data"></i>
            <div>
              <h4>项目总数</h4>
              <p>{{ homeTotal.EntriesCount }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="always">
          <div class="wrap">
            <i class="el-icon-s-flag" style="color: #67c23a"></i>
            <div>
              <h4>参与学校数</h4>
              <p>{{ homeTotal.SchoolCount }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="always">
          <div class="wrap">
            <i class="el-icon-s-custom" style="color: #409eff"></i>
            <div>
              <h4>评委数</h4>
              <p>{{ homeTotal.JudgesGroupCount }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="always">
          <div class="wrap">
            <i class="el-icon-s-claim" style="color: #f56c6c"></i>
            <div>
              <h4>赛道数</h4>
              <p>{{ homeTotal.TrackCount }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-card class="signchart">
      <div slot="header">
        <span>报名统计</span>
      </div>
      <ve-line :data="chartData" :settings="chartSettings"></ve-line>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    this.chartSettings = {
      legendName: {
        SignUpCount: '报名数'
      },
      labelMap: {
        SignUpCount: '报名数'
      }
    }
    return {
      homeTotal: {
        EntriesCount: '',
        SchoolCount: '',
        JudgesGroupCount: '',
        TrackCount: ''
      },
      chartData: {
        columns: ['SubDate', 'SignUpCount'],
        rows: [
          {
            SubDate: '2022-01-07',
            SignUpCount: 123
          }
        ]
      }
    }
  },
  created() {
    // 获取首页总数统计
    this.getHomeTotal()
    // 获取首页报名统计
    this.getSignUp()
  },
  methods: {
    async getHomeTotal() {
      const { data: res } = await this.$http.get('/api/HomeTotal/GetAdminTotal')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.homeTotal = res.Data.home
    },
    async getSignUp() {
      const { data: res } = await this.$http.get(
        '/api/HomeTotal/GetRegistrationStatistics'
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      // 格式化时间
      this.chartData.rows = res.Data.homes.map((item) => {
        return {
          SubDate: this.$moment(item.SubDate).format('YYYY-MM-DD'),
          SignUpCount: item.SignUpCount
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  display: flex;
  justify-content: space-between;
  i {
    font-size: 80px;
    color: #40c9c6;
  }
  h4 {
    font-size: 25px;
    margin: 0;
    color: #666;
  }
  p {
    font-size: 30px;
    color: #999;
    margin: 5px 0;
  }
}
.infouse {
  p {
    font-size: 14px;
    color: #666;
  }
}
.el-card {
  min-width: auto;
}
.signchart {
  margin-top: 20px;
}
</style>
